import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ActionSource } from 'src/app/state/action-sources';

import { Job_CalendarEventFragment } from '../../../generated/graphql.generated';

import { InventoryItem, InventoryItemDefinition, InventoryRoom, jobInventoryInitialState } from './job-inventory.state';

export type YemboCallState = 'yemboStartOnsite' | 'yemboSelfSurvey';

export const InventoryActions = createActionGroup({
  source: ActionSource.INVENTORY,
  events: {

    // Item search
    'Item Autocomplete Input Changed': props<{
      roomId: string;
      value: string;
    }>(),
    'Item Autocomplete Search Fired': props<{
      query: string;
    }>(),
    'Item Search Success': props<{
      items: InventoryItemDefinition[],
    }>(),
    'Item Autocomplete Item Selected': props<{
      item: InventoryItemDefinition;
      roomId: string;
      doFocus?: string;
    }>(),
    'Item Autocomplete Save Button Clicked': props<{
      roomId: string;
      doFocus?: string;
    }>(),
    'Item Autocomplete Enter Pressed': props<{
      key: KeyboardEvent;
      roomId: string;
      doFocus?: string;
    }>(),

    'Item Added': props<{
      roomId: string
      item: InventoryItem;
    }>(),

    'Item Edited': props<{
      roomId: string
      item: InventoryItem;
    }>(),

    // Other item actions
    'Item Quantity Input Changed': props<{
      itemId: string;
      roomId: string;
      quantity: number;
      doFocus?: string;
    }>(),

    'Remove Item Button Clicked': props<{
      roomId: string;
      itemId: string;
    }>(),

    // Edit Item Dialog
    'Edit Item Button Clicked': props<{ roomId: string; itemId: string }>(),

    'Exit Edit Item Button Clicked': emptyProps(),
    'Cancel Edit Item Button Clicked': emptyProps(),

    'Edit Item Dialog Name Input Changed': props<{ name: string }>(),
    'Edit Item Dialog Quantity Input Changed': props<{ quantity: number }>(),
    'Edit Item Dialog Weight Input Changed': props<{ weight: number }>(),
    'Edit Item Dialog Volume Input Changed': props<{ volume: number }>(),

    'Edit Item Dialog Accept Button Clicked': emptyProps(),

    // Room management
    'Edit Room Name In Place Confirm Button Clicked': props<{
      roomId: string;
      name: string;
    }>(),
    'Remove Room Button Clicked': props<{
      roomId: string;
    }>(),
    'Toggle Collapse Room Button Clicked': props<{ roomId: string }>(),

    // Add room dialog
    'Add Room Button Clicked': emptyProps(),
    'Exit Add Room Dialog Button Clicked': emptyProps(),
    'New Room Selected': props<{ name: string }>(),
    'Custom Room Name Input Changed': props<{
      name: string
    }>(),
    'Custom Room Name Enter Pressed': emptyProps(),
    'Add Custom Room Button Clicked': emptyProps(),
    'Room Added': props<{ room: InventoryRoom }>(),

    // Yembo
    'View Move In Yembo Button Clicked': emptyProps(),
    'Create Self Survey Link Menu Item Clicked': emptyProps(),
    'Create Self Survey Link Confirmation Dialog Closed': props<{
      confirmed: boolean;
    }>(),
    'Create Self Survey Link Success': props<{
      customerLink: string;
      employeeLink: string;
      jobId: string;
    }>(),
    'Create Self Survey Link Error': props<{
      error: Error;
    }>(),

    'Start Onsite Button Clicked': emptyProps(),
    'Start Onsite Confirm Button Clicked': emptyProps(),
    'Start Onsite Success': props<{
      jobId: string,
      employeeLink: string,
      customerLink: string,
    }>(),
    'Start Onsite Error': props<{
      error: Error,
    }>(),
    'Book Yembo Smart Consult Button Clicked': emptyProps(),
    'Initial Yembo Options Loaded': props<{
      yemboOptions: typeof jobInventoryInitialState['yemboOptions'];
    }>(),
    'Create Virtual Estimate Success': props<{
      createdEvent: Job_CalendarEventFragment,
      jobId: string;
      eventId: string;
    }>(),
    'Create Virtual Estimate Error': props<{
      error: Error,
    }>(),

    // Qube Sheets
    'Book Video Call Button Clicked': emptyProps(),
    'View Qube Sheets Project Button Clicked': emptyProps(),
    'View Qube Sheets Project Button Succeeded': emptyProps(),
    'View Qube Sheets Project Button Failed': props<{
      error: Error;
    }>(),
  },
});
